<div
  (cdkDragStarted)="onMoveToFront()"
  [cdkDragFreeDragPosition]="dragPosition$ | async"
  [ngStyle]="styles"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  class="bg-white border border-gray-400 flex flex-col resize"
>
  <button
    (click)="onMoveToFront()"
    cdkDragHandle
    class="overlay-header px-2 border-bottom text-white flex gap-2 items-center justify-between cursor-grab"
  >
    <span>{{ title | transloco }}</span>

    <div>
      <button (click)="smallOverlay()" mat-icon-button>
        <mat-icon>tile_small</mat-icon>
      </button>

      <button (click)="mediumOverlay()" mat-icon-button>
        <mat-icon>tile_medium</mat-icon>
      </button>

      <button (click)="largeOverlay()" mat-icon-button>
        <mat-icon>tile_large</mat-icon>
      </button>

      <button (click)="minimize()" mat-icon-button>
        <mat-icon>minimize</mat-icon>
      </button>

      <button (click)="close()" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </button>

  <div class="flex-auto overflow-auto">
    @switch (contentType) { @case ('string') {
    <div class="box">
      <div [innerHTML]="content"></div>
    </div>
    } @case ('template') {
    <ng-container *ngTemplateOutlet="content; context: context"></ng-container>
    } @case ('component') {
    <ng-container *ngComponentOutlet="content"></ng-container>
    } }
  </div>
</div>
